import { Injectable } from '@angular/core';
import {GenericResponse } from '../business-entities/generic-response'
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class LanguageDataService
{
    constructor(private dataProvider: DataService) {
    }

    getAllLanguage():Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAllLanguage).toPromise();
    } 
    getLocalizationData(languageCode: string): Observable<any>
    {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetLocalizationData,languageCode);
    }
}